/** @sfdc-extension-file SFDC_EXT_BRD_LOGIN_SIDEBAR */
import { lazy, type ReactElement, Suspense, useEffect, useState } from 'react';
import { useAuthSheet } from '@/extensions/brd-login-sidebar/providers/auth-sheet';

const AuthDrawer = lazy(() => import('./auth-drawer'));

/**
 * Lazily mounts the controlled login/register sidebar the first time it is opened
 * (from the header icon or guest quick links), then keeps it mounted for the rest
 * of the session. Deferring the import keeps the multi-step auth drawer out of the
 * initial header bundle, mirroring how the mini-cart is deferred until first interaction.
 *
 * Loyalty CMS warmup happens on header hover/focus and as an idle fallback in
 * AuthDecision — not on every guest page mount here.
 */
export default function AuthDrawerMount(): ReactElement | null {
    const { authSheetOpen } = useAuthSheet();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (authSheetOpen) {
            setMounted(true);
        }
    }, [authSheetOpen]);

    if (!mounted) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <AuthDrawer />
        </Suspense>
    );
}
